import SectionHeader from "components/Common/SectionHeader"
import React from "react"
import { Badge, Card, CardBody } from "reactstrap"

export default function DataBadgeCard({ data, icon, title, action, name }) {
  return (
    <Card className="border-0 shadow-sm h-100">
      <CardBody className="p-3">
        <SectionHeader icon={icon} title={title} action={action} />
        {data && data.length > 0 ? (
          <div className="d-flex flex-wrap gap-2">
            {data.map(item => (
              <Badge className="py-2 px-3 badge-soft-info" key={item.id}>
                <i className="bx bx-check me-1"></i>
                {item.name}
              </Badge>
            ))}
          </div>
        ) : (
          <p className="text-muted mb-0">No {name} listed</p>
        )}
      </CardBody>
    </Card>
  )
}
